import styled, { css } from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

import type { InlineDetailRowLayout } from "./InlineDetailRow.types";

const rowLayoutStyles = ($layout: InlineDetailRowLayout) =>
  $layout === "grid-row"
    ? css`
        display: contents;
      `
    : css`
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: ${spacing[3]};
        min-width: 0;
      `;

export const Row = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "$layout",
})<{ $layout: InlineDetailRowLayout }>`
  ${({ $layout }) => rowLayoutStyles($layout)}
`;

const labelLayoutStyles = ($layout: InlineDetailRowLayout) =>
  $layout === "grid-row"
    ? css`
        flex: unset;
        min-width: 0;
        justify-self: start;
      `
    : css`
        flex: 0 0 25%;
      `;

export const Label = styled.span.withConfig({
  shouldForwardProp: (prop) => prop !== "$layout",
})<{ $layout: InlineDetailRowLayout }>`
  ${typographyMixin("body", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
  ${({ $layout }) => labelLayoutStyles($layout)}
`;

const valueLayoutStyles = ($layout: InlineDetailRowLayout) =>
  $layout === "grid-row"
    ? css`
        flex: unset;
        min-width: 0;
        justify-self: start;
      `
    : css`
        flex: 1 1 auto;
      `;

export const Value = styled.span.withConfig({
  shouldForwardProp: (prop) => prop !== "$layout",
})<{ $layout: InlineDetailRowLayout }>`
  ${typographyMixin("body", 3)}
  color: ${({ theme }) => theme.colors.text.primary};
  display: inline-flex;
  align-items: center;
  gap: ${spacing[2]};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${({ $layout }) => valueLayoutStyles($layout)}
`;
